// services/AuthService.js

import axiosClient from '../configs/axios';

class AuthService {
    // Login
   async login(payload) {
    try {
        const response = await axiosClient.post('/login/login', payload);
        const loginUser = response.data.result;

        sessionStorage.setItem('loginUser', JSON.stringify(response.data));
        sessionStorage.setItem('authtoken', loginUser?.authToken);

        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || 'Login failed');
    }
}

  async logout(logout) {
  try {
    const response = await axiosClient.post('/login/logout', logout);
    // You don't need to read token or user_id from response, you have them before logout call
    sessionStorage.removeItem('loginUser');
    sessionStorage.removeItem('authtoken');
    return response.data; // return the actual response for checking success
  } catch (error) {
    throw new Error('Logout failed');
  }
}


    // Optionally: Get stored token
    getToken() {
        return sessionStorage.getItem('authtoken');
    }

    // Optionally: Check if user is logged in
    isAuthenticated() {
        return !!sessionStorage.getItem('authtoken');
    }
}

export default new AuthService();
